import PropTypes from "prop-types";
import styled from "styled-components";

const StyledYesNoCell = styled.div`
  min-width: 80px;
  width: 172px;
  padding-left: 4px;
  border-left: 1px solid rgba(0, 0, 0, 0.07);

  @media screen and (min-width: 540px) {
    width: 144px;
  }
`;

const YesNoCell = ({ children }) => (
  <StyledYesNoCell>{children}</StyledYesNoCell>
);

YesNoCell.propTypes = {
  children: PropTypes.node,
};

export default YesNoCell;
